import { render } from "./Opinion.vue?vue&type=template&id=757ec89e&scoped=true"
import script from "./Opinion.vue?vue&type=script&lang=js"
export * from "./Opinion.vue?vue&type=script&lang=js"

import "./Opinion.vue?vue&type=style&index=0&id=757ec89e&scoped=true&lang=scss"

import exportComponent from "D:\\wjm\\offical-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-757ec89e"]])

export default __exports__